import React from 'react';

/**
 * Sidebar label for the Clive Insights tab.
 *
 * The count is dropped rather than shown as `(0)`: an empty count reads as a defect on a tab that
 * usually carries a number, which is why the Documents tab does the same.
 */
export const CliveInsightsTabLabel: React.FC<{ undismissedCount: number }> = ({ undismissedCount }) => (
  <>{undismissedCount > 0 ? `Clive Insights (${undismissedCount})` : 'Clive Insights'}</>
);
